

import {SETTINGS_ROUTES} from "@/modules/settings/router/SettingsRoutes";
import {VEHICLE_ROUTES} from "@/modules/vehicles/router/vehicleRouter";
import {CONTACT_ROUTES} from "@/modules/contacts/router/contactRouter";
import {REMINDER_ROUTES} from "@/modules/reminders/routes/reminderRouter";
import {SERVICE_ROUTES} from "@/modules/services/router/serviceRoutes";
import {WORKFLOW_ROUTES} from "@/modules/workflow/router/WorkflowRouter";
import {INSPECTION_ROUTES} from "@/modules/inspections/router/inspectionRouter";

import {ISSUE_ROUTES} from "@/modules/issues/router/issueRouter";
import {FUEL_ROUTES} from "@/modules/fuel/router/fuelRouter";
import {EXPENSE_ROUTES} from "@/modules/expense/router/expenseRouter";
import {INVENTORY_ROUTES} from "@/modules/inventory/router/InventoryRouter";
import {PLACE_ROUTES} from "@/modules/places/router/PlaceRouter";
import {MAP_ROUTES} from "@/modules/maps/router/MapRouter";
import {REPORT_ROUTES} from "@/modules/reports/router/reportRouter";
import {MESSAGE_ROUTES} from "@/modules/messaging/router/messagingRoutes";

import {VIDEO_ROUTES} from "@/modules/video/router/VideoRouter";

import MapsPage from "@/modules/maps/layouts/MapsPage";
import MapPage  from "@/modules/maps/layouts/MapPage";

export const MAIN_ROUTES = [
    {
        path: "dashboard",
        name: "dashboard",
        component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/modules/dashboard/layouts/DashboardPage"),
    },
    {
        path:"blank",
        name: "blank",
        component: () =>
            import(/* webpackChunkName: "global" */ "@/modules/global/layouts/BlankPage")
    },

    {
        path: "maps/:tabID?",
        name: "maps",
        component: MapsPage,
    },
    {
        path: "map/:mapID",
        name: "map",
        component: MapPage,
        children: MAP_ROUTES,
    },

    {
        path: "workflows/:tabID?",
        name: "workflows",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/layouts/WorkflowsPage"),
    },
    {
        path: "workflow/:workflowID",
        name: "workflow",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/layouts/WorkflowPage"),
        children: WORKFLOW_ROUTES,
    },
    {
        path: "inspections/:tabID?",
        name: "inspections",
        component: () =>
            import(/* webpackChunkName: "inspections" */ "@/modules/inspections/layouts/InspectionsPage"),
    },
    {
        path: "inspection/:inspectionID",
        name: "inspection",
        component: () =>
            import(/* webpackChunkName: "inspections" */ "@/modules/inspections/layouts/InspectionPage"),
        children: INSPECTION_ROUTES,
    },

    {
        path: "issues",
        name: "issues",
        component: () =>
            import(/* webpackChunkName: "issues" */ "@/modules/issues/layouts/IssuesPage"),
    },
    {
        path: "issue/:issueID",
        name: "issue",
        component: () =>
            import(/* webpackChunkName: "issues" */ "@/modules/issues/layouts/IssuePage"),
        children: ISSUE_ROUTES,
    },

    {
        path: "fuels/:tabID?",
        name: "fuels",
        component: () =>
            import(/* webpackChunkName: "fuel" */ "@/modules/fuel/layouts/FuelsPage"),
    },
    {
        path: "fuel/:fuelID",
        name: "fuel",
        component: () =>
            import(/* webpackChunkName: "expense" */ "@/modules/expense/layouts/ExpensePage.vue"),
        children: EXPENSE_ROUTES,
    },
    {
        path: "expenses/:tabID?",
        name: "expenses",
        component: () =>
            import(/* webpackChunkName: "expense" */ "@/modules/expense/layouts/ExpensesPage.vue"),
    },
    {
        path: "expense/:expenseID",
        name: "expense",
        component: () =>
            import(/* webpackChunkName: "fuel" */ "@/modules/fuel/layouts/FuelPage"),
        children: FUEL_ROUTES,
    },
    {
        path: "videos/:tabID?",
        name: "videos",
        component: () =>
            import(/* webpackChunkName: "video" */ "@/modules/video/layouts/VideosPage"),
    },
    {
        path: "video/:videoID",
        name: "video",
        component: () =>
            import(/* webpackChunkName: "video" */ "@/modules/video/layouts/VideoPage"),
        children: VIDEO_ROUTES,
    },

    {
        path: "reminders/:tabID?",
        name: "reminders",
        component: () =>
            import(/* webpackChunkName: "reminders" */ "@/modules/reminders/layouts/RemindersPage"),
    },

    {
        path: "reminder/:reminderID",
        name: "reminder",
        component: () =>
            import(/* webpackChunkName: "reminders" */ "@/modules/reminders/layouts/ReminderPage"),
        children: REMINDER_ROUTES,
    },

    {
        path: "services/:tabID?",
        name: "services",
        component: () =>
            import(/* webpackChunkName: "services" */ "@/modules/services/layouts/ServicesPage"),
    },

    {
        path: "service/:serviceID",
        name: "service",
        component: () =>
            import(/* webpackChunkName: "services" */ "@/modules/services/layouts/ServicePage"),
        children: SERVICE_ROUTES,
    },

    {
        path: "vehicles/:tabID?",
        name: "vehicles",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/VehiclesPage"),
    },
    {
        path: "vehicle/:vehicleID",
        name: "vehicle",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/VehiclePage"),
        children: VEHICLE_ROUTES,
    },

    {
        path: "contacts/:tabID?",
        name: "contacts",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/ContactsPage"),
    },
    {
        path: "contact/:contactID",
        name: "contact",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/ContactPage"),
        children: CONTACT_ROUTES,
    },

    {
        path: "inventorys/:tabID?",
        name: "inventorys",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/layouts/InventorysPage"),
    },
    {
        path: "inventory/:itemID",
        name: "inventory",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/layouts/InventoryPage"),
        children: INVENTORY_ROUTES,
    },
    {
        path: "places/:tabID?",
        name: "places",
        component: () =>
            import(/* webpackChunkName: "places" */ "@/modules/places/layouts/PlacesPage"),
    },
    {
        path: "place/:placeID",
        name: "place",
        component: () =>
            import(/* webpackChunkName: "places" */ "@/modules/places/layouts/PlacePage"),
        children: PLACE_ROUTES,
    },

    {
        path: "reports/:tabID?",
        name: "reports",
        component: () =>
            import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/ReportsPage"),
    },
    {
        path: "report/:reportID?",
        name: "report",
        component: () =>
            import(/* webpackChunkName: "reports" */ "@/modules/reports/layouts/ReportPage"),
        children: REPORT_ROUTES,
    },

    {
        path: "planning/:tabID?",
        name: "planning",
        component: () =>
            import(/* webpackChunkName: "planning" */ "@/modules/planning/layout/PlanningPage.vue"),
    },

    {
        path: "settings",
        name: "settings",
        component: () =>
            import(/* webpackChunkName: "settings" */ "@/modules/settings/layouts/SettingsPage"),
        children: SETTINGS_ROUTES,
    },

    {
        path: "messages",
        name: "messages",
        component: () =>
            import(/* webpackChunkName: "messaging" */ "@/modules/messaging/layouts/MessegesPage"),
    },

    {
        path: "message/:messageID",
        name: "message",
        component: () =>
            import(/* webpackChunkName: "messaging" */ "@/modules/messaging/layouts/MessagePage"),
        children: MESSAGE_ROUTES,
    },
    {
        path: "llm",
        name: "llm",
        component: () =>
            import(/* webpackChunkName: "ai" */ "@/modules/ai/layouts/LLMLayoutPage.vue"),
    }
];
